import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3cf72acc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "account-main box-flex-column" }
const _hoisted_2 = { class: "account-main__top" }
const _hoisted_3 = { class: "account-main__account" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "account-main__label" }, "账户余额（元）", -1))
const _hoisted_5 = { class: "account-main__banks" }
const _hoisted_6 = {
  key: 0,
  class: "account-main__banks__item"
}
const _hoisted_7 = { class: "account-main__banks__label" }
const _hoisted_8 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_9 = { style: {"margin-right":"6px"} }
const _hoisted_10 = {
  key: 0,
  class: "account-main__banks__line"
}
const _hoisted_11 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-right":"6px"} }, "网银支付", -1))
const _hoisted_13 = { class: "account-main__money" }
const _hoisted_14 = { class: "account-mainmain__money__num" }
const _hoisted_15 = { class: "account-mainmain__money__btn" }

import { ref, onMounted, computed } from 'vue';
import {
  BaseButton,
  useCreateModal,
  BaseIcon,
  XrkMessage,
  BaseLayoutFlexContent
} from 'xrk-components';
import AccountMainList from '../components/account-main-list.vue';
import AccountMainWithdrawalDialog from '../components/account-main-withdrawal-dialog.vue';
import AccountMainRechargeDialog from '../components/account-main-recharge-dialog.vue';
import { getEnterpriseAccountBalance } from '../data-source/apis';
import { GetEnterpriseAccountBalanceData } from '../data-source/types';
import { useBank } from '../hooks/index';
import { pushfyDetail } from '../router';
import { formatter } from '@/utils';
// import { FunctionCode } from '@cTypes/user';
import AccountMainWithdrawalOrdersDialog from '../components/account-main-withdrawal-orders-dialog.vue';
import { useRouteMeta } from '@hooks/common';
import { ArrowRightBold } from '@element-plus/icons-vue';
import AccountOnlineConfigDialog from '../components/account-online-config-dialog.vue';
import { IS_PLATFORM_TYPE_1, IS_ASSISTANT } from '@/config';


export default /*#__PURE__*/_defineComponent({
  __name: 'account-main',
  setup(__props) {

const OPEN_STATUS_TEXT = {
  10: '开户申请',
  20: '开通中',
  30: '已开通',
  40: '开通失败'
};

const { banks, updateBanks, openInfo } = useBank();
const routeMeta = useRouteMeta();
const isAsp = [2].includes(+routeMeta.functionCode);
const isSupplier = [3].includes(+routeMeta.functionCode);
const isDbgys = [8].includes(+routeMeta.functionCode);

/** 已开通时按 isOverSixMonths 追加银行账户文案（供应商不涉及） */
const getActOpenStatusText = (item: {
  actOpenStatus: number;
  isOverSixMonths?: 0 | 1;
}) => {
  const text = OPEN_STATUS_TEXT[item.actOpenStatus] || '';
  // 供应商保持原开户状态文案，不追加银行账户说明
  if (isSupplier || item.actOpenStatus !== 30) return text;
  if (item.isOverSixMonths === 1) return `${text}（已开通银行账户）`;
  if (item.isOverSixMonths === 0) return `${text}（未开通银行账户）`;
  return text;
};

const accountMainListRef = ref();
const companyInfo = ref<GetEnterpriseAccountBalanceData>({
  balance: 0,
  amount: 0,
  waitAmount: 0
});

const bankApproved = computed(() => {
  const t = banks.value.find(
    item => item.value === 'fyBank' && item.actOpenStatus === 30
  );
  // 只有富友可以提现、充值
  return t;
});

const setCompany = async () => {
  const { data } = await getEnterpriseAccountBalance();
  companyInfo.value = data;
};
const init = async () => {
  updateBanks();
  setCompany();
};

const onOpenBank = (item: (typeof banks.value)[0]) => {
  if (!item.enabled) return; // 未启用不可进入
  pushfyDetail({
    payPassagewayCode: 'fyBank'
  });

  // useCreateModal(AccountInfoDialog, {
  //   payPassagewayCode: item.payPassagewayCode,
  //   onSuccess() {
  //     init();
  //     accountMainListRef.value.init();
  //   }
  // });
};

const onRecharge = () => {
  useCreateModal(AccountMainRechargeDialog);
};
const onWithdrawal = () => {
  if (isAsp || isDbgys) {
    useCreateModal(AccountMainWithdrawalDialog, {
      onSuccess() {
        init();
      }
    });
  }
  if (isSupplier) {
    useCreateModal(AccountMainWithdrawalOrdersDialog, {
      onSuccess() {
        init();
      }
    });
  }
};
const onOnlineConfig = () => {
  if (!openInfo.value.deptId) {
    XrkMessage.error('数据异常');
    return;
  }
  useCreateModal(AccountOnlineConfigDialog, {
    deptId: openInfo.value.deptId,
    entpName: openInfo.value.entpName,
    onSuccess() {
      init();
    }
  });
};

onMounted(() => {
  init();
});

return (_ctx: any,_cache: any) => {
  const _directive_resource = _resolveDirective("resource")!
  const _directive_xrk_loading = _resolveDirective("xrk-loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(banks), (item) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: item.label
            }, [
              (item.enabled)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("span", _hoisted_7, _toDisplayString(item.label), 1),
                    _createVNode(_unref(BaseButton), {
                      link: "",
                      type: "primary",
                      onClick: ($event: any) => (onOpenBank(item))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("span", _hoisted_9, _toDisplayString(getActOpenStatusText(item)), 1),
                          _createVNode(_unref(BaseIcon), { size: "12" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(ArrowRightBold))
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          }), 128)),
          (_unref(IS_PLATFORM_TYPE_1) && !_unref(IS_ASSISTANT))
            ? (_openBlock(), _createElementBlock("div", _hoisted_10))
            : _createCommentVNode("", true),
          (_unref(IS_PLATFORM_TYPE_1) && !_unref(IS_ASSISTANT))
            ? (_openBlock(), _createBlock(_unref(BaseButton), {
                key: 1,
                link: "",
                type: "default",
                onClick: onOnlineConfig
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_11, [
                    _hoisted_12,
                    _createVNode(_unref(BaseIcon), { size: "12" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(ArrowRightBold))
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])), [
          [_directive_resource, ['支付通道']]
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(formatter).fen2yuan(companyInfo.value.balance)), 1),
        _createElementVNode("div", _hoisted_15, [
          (bankApproved.value && companyInfo.value.amount)
            ? _withDirectives((_openBlock(), _createBlock(_unref(BaseButton), {
                key: 0,
                style: {"margin-top":"24px"},
                onClick: onWithdrawal
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 提现 ")
                ]),
                _: 1
              })), [
                [_directive_resource, ['提现']]
              ])
            : _createCommentVNode("", true),
          (bankApproved.value)
            ? _withDirectives((_openBlock(), _createBlock(_unref(BaseButton), {
                key: 1,
                style: {"margin-top":"24px"},
                type: "default",
                onClick: onRecharge
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 充值 ")
                ]),
                _: 1
              })), [
                [_directive_resource, ['充值']]
              ])
            : _createCommentVNode("", true)
        ])
      ])
    ])), [
      [_directive_xrk_loading, !_unref(banks).length]
    ]),
    _createVNode(_unref(BaseLayoutFlexContent), null, {
      default: _withCtx(() => [
        _createVNode(AccountMainList, {
          ref_key: "accountMainListRef",
          ref: accountMainListRef
        }, null, 512)
      ]),
      _: 1
    })
  ]))
}
}

})